
export interface IProductReview {
    reviewSummary: string;
    totalReviewCount: number;
    oneRatingsCount: number;
    twoRatingsCount: number;
    threeRatingsCount: number;
    fourRatingsCount: number;
    fiveRatingsCount: number;
}


export class ProductReview implements IProductReview {
    public reviewSummary: string = '';
    public totalReviewCount: number = 0;
    public oneRatingsCount: number = 0;
    public twoRatingsCount: number = 0;
    public threeRatingsCount: number = 0;
    public fourRatingsCount: number = 0;
    public fiveRatingsCount: number = 0;
}


